/**
 * possible values for the pageBreak column are:
 * 1. na: no page break
 * 2. before: page break before the current trial
 * 3. after or 1: page break after the current trial
 * @param {int} trialRow
 * @param {int} trial
 * @param {function} columnForTrial
 * @param {array} stimOrder
 * @returns {boolean} true if the current form trial should have a page break
 */
function shouldEndFormScreen(trialRow, trial, columnForTrial, stimOrder) {
    const currentTrialPageBreak = columnForTrial('pageBreak', trialRow);
    // we should have a page break if the pageBreak value for the current trial is 1 or after or if the next trial has pageBreak=before

    // pageBrake=before
    //let's first check for the next trial
    const nextTrialRow = stimOrder[trial + 1];

    if (nextTrialRow) {
        const nextTrialPageBreak = columnForTrial('pageBreak', nextTrialRow);
        if (nextTrialPageBreak === 'before') {
            return true
        }
    }

    // if the trial is a generated one from dynamic lists, and is the last one in the list, and the value of the pageBreak column is afterAll, we should have a page break
    if (currentTrialPageBreak === 'afterAll') {
        const isGeneratedTrial = !!window.dynamicLists.dynamicListsValues[trialRow];
        const isLastTrialInList = !window.dynamicLists.hasMoreDynamicValuesForTrial(trialRow);

        if (isGeneratedTrial && isLastTrialInList) {
            return true
        }

        return false;
    }

    // pageBrake after or 1 or any other value that is not na or before
    // the legacy code had for pageBreak != 'na'
    // if there's a page break, start for the accumulated form trials
    if (currentTrialPageBreak !== 'na' && currentTrialPageBreak !== 'before') {
        return true
    }

    return false;
}